import { ClassDefinitionItemDto } from '@zorro/clients';

export const ALL_EMPLOYEES_CLASS_NAME = 'All Employees';

export function buildClassLabel(
  workStatusLabel?: string,
  geoValue?: string
): string {
  if (workStatusLabel && geoValue)
    return [workStatusLabel, geoValue].join(', ');
  if (geoValue) return geoValue;
  if (workStatusLabel) return workStatusLabel;
  return ALL_EMPLOYEES_CLASS_NAME;
}

export interface ClassMatchingData {
  state?: string | null;
  ratingArea?: string | null;
  employmentType?: string | null;
  wageType?: string | null;
  customClassCategory?: string | null;
}

export function isEmployeeMissingRequiredData(
  classDefinition: ClassDefinitionItemDto,
  insuredEmployee: ClassMatchingData
): boolean {
  return Boolean(
    (classDefinition.state && !insuredEmployee.state) ||
    (classDefinition.ratingArea && !insuredEmployee.ratingArea) ||
    (classDefinition.employmentType && !insuredEmployee.employmentType) ||
    (classDefinition.wageType && !insuredEmployee.wageType) ||
    (classDefinition.customClassCategory &&
      classDefinition.customClassCategory !== ALL_EMPLOYEES_CLASS_NAME &&
      !insuredEmployee.customClassCategory)
  );
}

function compareFieldFromClassToEmployee(
  classValue: string | undefined,
  employeeValue: string | null | undefined
): boolean {
  if (!classValue) return true;
  if (!employeeValue) return false;

  return classValue.toLowerCase() === employeeValue.toLowerCase();
}

export function matchClassDefinitionToEmployee(
  classDefinition: ClassDefinitionItemDto,
  insuredEmployee: ClassMatchingData
): string | null {
  const fieldsToCheck = [
    { class: classDefinition.state, employee: insuredEmployee.state },
    { class: classDefinition.ratingArea, employee: insuredEmployee.ratingArea },
    {
      class: classDefinition.employmentType,
      employee: insuredEmployee.employmentType,
    },
    { class: classDefinition.wageType, employee: insuredEmployee.wageType },
  ];

  if (
    classDefinition.customClassCategory &&
    classDefinition.customClassCategory !== ALL_EMPLOYEES_CLASS_NAME
  ) {
    fieldsToCheck.push({
      class: classDefinition.customClassCategory,
      employee: insuredEmployee.customClassCategory,
    });
  }

  const allFieldsMatch = fieldsToCheck.every(
    ({ class: classValue, employee: employeeValue }) =>
      compareFieldFromClassToEmployee(classValue, employeeValue)
  );

  return allFieldsMatch ? classDefinition.className : null;
}

export function findMatchingClass(
  classDefinitions: ClassDefinitionItemDto[],
  insuredEmployee: ClassMatchingData
): string | null {
  for (const classDefinition of classDefinitions) {
    const matchResult = matchClassDefinitionToEmployee(
      classDefinition,
      insuredEmployee
    );

    if (matchResult) {
      return matchResult;
    }
  }

  return null;
}
